var scope_0 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/16bb39f6040063bb99574ee7ab9adaf6.js').default;
var scope_1 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/38cf156cc49c41696981e0a81dc1a0b7.js').default;
var scope_2 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a2ce7070f570e2b8d6dd5ab40f3b46b7.js').default;
var scope_3 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c6b40b0e19150f950b31f88a0bc6d544.js').default;
var scope_4 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cae38f831824e8c2364ad1ddae0f1a0a.js').default;
var scope_5 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cb84dc73192614689350ae0e3b62d30f.js').default;
var scope_6 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_7 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/efa63aa4601b7ee7c19401c7ade5d163.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7 )
    